import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components/misc'

export const StyledContainer = styled.div`
  margin-bottom: 16px;
`

export const StyledHeading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
`

export const StyledSocialContainer = styled.div`
  display: flex;
  padding: 0 16px;

  ${MediaQueries.mbUp} {
    align-items: center;
    justify-content: center;
  }
  .share-icon {
    svg {
      width: 32px;
      height: 32px;
    }
    flex-shrink: 0;
    margin-right: 0.7em;
    &:last-child {
      margin-right: unset;
    }
    > a {
      display: flex;
      * {
        pointer-events: none;
      }
    }
  }
`
